import Head from '../Head';
import Header from '../Header';
import HeaderMobile from '../HeaderMobile';
import Footer from '../Footer';
import CalculatorResultAwards from '../CalculatorResultAwards';
import PreFooter from '../PreFooter';

const PageLayout = ({
  menuData,
  aboutMenuData,
  serviceMenuData,
  toolsMenuData,
  yoastSeo,
  schema,
  seo,
  classNames = '',
  children,
  pageSchemaSet,
  isSidebarHidden,
  showMenu,
  indexStatus,
  pageId,
}) => {
  return (
    <>
      <Head
        yoastSeo={yoastSeo}
        schema={schema}
        seo={seo}
        pageSchemaSet={pageSchemaSet}
        isSidebarHidden={isSidebarHidden}
        indexStatus={indexStatus}
      />
      <noscript
        dangerouslySetInnerHTML={{
          __html: `
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-T5XNDHQ"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `,
        }}
      ></noscript>
      <HeaderMobile
        menuData={menuData}
        aboutMenuData={aboutMenuData}
        serviceMenuData={serviceMenuData}
        toolsMenuData={toolsMenuData}
        showMenu={showMenu}
      />
      <Header
        menuData={menuData}
        aboutMenuData={aboutMenuData}
        serviceMenuData={serviceMenuData}
        toolsMenuData={toolsMenuData}
        showMenu={showMenu}
      />
      <main className={`page-layout ${classNames}`}>{children}</main>
      {pageId === 162117679 && <CalculatorResultAwards />}
      <PreFooter />
      <Footer />
    </>
  );
};

export default PageLayout;
